// Shared SSO configuration for the Office add-in.
//
// The add-in cannot run a normal redirect-based OAuth flow inside the task
// pane (it lives in a sandboxed WebView), so sign-in happens in an Office
// dialog window instead. The dialog page (`dialog.html`) is served from the
// add-in's own origin and is the OAuth redirect URI for both identity
// providers. These client IDs / domains are the SAME app registrations the
// MyTender web app uses; they are public values shipped in the browser bundle.

export type SsoProvider = "entra" | "auth0";

export const ENTRA_ID_CLIENT_ID = process.env.REACT_APP_ENTRA_ID_CLIENT_ID || "";
export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN || "";
export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID || "";

// Multi-tenant Entra authority, matching the web app (App.tsx msalConfig).
export const ENTRA_AUTHORITY = "https://login.microsoftonline.com/organizations";

// Scopes requested from both providers, matching the web app SignIn.tsx.
export const SSO_SCOPES = ["openid", "profile", "email", "offline_access"];

// The dialog page doubles as the OAuth redirect URI. Both the task pane and
// the dialog share the same origin, so this resolves identically in either.
export const dialogRedirectUri = (): string => `${window.location.origin}/dialog.html`;

export const isEntraConfigured = (): boolean => Boolean(ENTRA_ID_CLIENT_ID);
export const isAuth0Configured = (): boolean => Boolean(AUTH0_DOMAIN && AUTH0_CLIENT_ID);
